export enum BookingStep {
  PackageSelection = 'SELECT_PACKAGE',
  DealerSelection = 'SELCECT_DEALER',
}

export type ServicingPackage = {
  amount: number;
  packageName?: string;
  checked: boolean;
  packageId: number;
  specs: string[];
  dealerId?: string;
  quotePrice?: number;
};

export type ServicingAddons = {
  addOnId: number;
  imgUrl: string;
  addonName: string;
  addonDescription: string;
  amount: number;
  checked: boolean;
};

export type VehicleKms = {
  text: string;
  start: number;
  end: number;
  numOfYears: number;
};
